module.exports = __webpack_public_path__ + "img/1_1-stazione_carburante-1-eolico.e732c20b.png";